var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

import React from "react";
export default ((_ref) => {
  let {
    styles = {}
  } = _ref,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return React.createElement(
    "svg",
    _extends({ width: "25", height: "24", viewBox: "0 0 25 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
    React.createElement("path", { d: "M12.1909 15C15.5046 15 18.1909 12.3137 18.1909 9 18.1909 5.68629 15.5046 3 12.1909 3 8.87721 3 6.19092 5.68629 6.19092 9 6.19092 12.3137 8.87721 15 12.1909 15zM3.09619 20.2491C4.01828 18.6531 5.34414 17.3278 6.94058 16.4064 8.53702 15.485 10.3478 15 12.1911 15 14.0343 15 15.8451 15.4851 17.4415 16.4065 19.038 17.3279 20.3638 18.6533 21.2859 20.2493", stroke: "#222429", strokeWidth: "1.5", strokeLinecap: "round", strokeLinejoin: "round" })
  );
});